import AdvancedConfigOption from './AdvancedConfigOption'

export default AdvancedConfigOption
